<template>
  <b-container fluid class="padding-none tailieWidget mb-5">
    <!-- <p>hello</p> -->

    <h1>{{ $t("login-email-main-title") }}</h1>
    <b-form @submit="onSubmit">
      <b-form-group
        id="label-sidebar-email"
        :label="$t('email')"
        label-for="input-sidebar-email"
        label-class="tailie-input-label"
        label-id="tailieEmailLabel"
      >
        <b-form-input
          id="input-sidebar-email"
          class="tailie-input shadow-none border-gray border rounded"
          :class="{ 'tailie-input-invalid': invalid }"
          :state="valid"
          v-model="form.email"
          v-on:focus.native="onFocus"
          type="email"
          required
        />
      </b-form-group>

      <b-form-group
        id="label-sidebar-password"
        :label="$t('password')"
        label-for="input-sidebar-password"
        label-class="tailie-input-label"
        label-id="tailiePasswordLabel"
      >
        <b-form-input
          id="input-sidebar-password"
          class="tailie-input shadow-none border-gray border rounded"
          :class="{ 'tailie-input-invalid': !valid }"
          :state="valid"
          v-model="form.password"
          v-on:focus.native="onFocus"
          type="password"
          required
        />
        <b-form-invalid-feedback id="input-live-feedback">
          {{ $t("login-email-login-failed") }}
        </b-form-invalid-feedback>
      </b-form-group>

      <div id="tailieLoginForgot" class="text-right">
        <b-button
          @click="$router.push({ name: 'password-reset-request' })"
          variant="link"
          class="text-dark-gray "
          >{{ $t("login-email-forgot-password") }}
        </b-button>
      </div>
      <b-form-group id="tailieLoginButton">
        <b-button
          type="submit"
          :style="$store.getters['pageParams/secondaryBgColor']"
          :disabled="loading"
          class="border-black border bg-black text-white shadow-none"
        >
          {{ $t("login") }}
        </b-button>
      </b-form-group>
    </b-form>
    <b-button
      variant="link"
      class="text-dark-gray"
      @click="$router.replace({ name: 'login-app' })"
    >
      <p class="d-none d-md-block">
        <QrIcon class="mr-1" />
        <u>{{ $t("login-email-login-with-qr") }}</u>
      </p>
      <p class="d-md-none d-block">{{ $t("login-email-login-with-app") }}</p>
    </b-button>
  </b-container>
</template>
<script>
import { mapGetters } from "vuex";
import QrIcon from "../../assets/images/qr-icon.svg";

export default {
  name: "login-email",
  components: {
    QrIcon
  },
  computed: {
    ...mapGetters({
      imageLink: "pageParams/getImageLink",
      loading: "ui/loading"
    })
  },
  data() {
    return {
      form: {
        email: "",
        password: ""
      },
      valid: true
    };
  },
  mounted: function() {
    this.$gtag.event("login_email", { method: "Google" });
  },
  methods: {
    toggleLoginForm() {
      this.show_app_login = !this.show_app_login;
    },
    checkQRLogin() {
      this.$store
        .dispatch("auth/qrlogin", { code: this.qrcode.data.token })
        .then(() => {
          this.$router.push({ name: "overview" });
        })
        .catch(() => {
          setTimeout(function() {
            this.checkQRLogin();
          }, 5000);
        });
    },
    onSubmit(evt) {
      evt.preventDefault();
      this.$store.commit("ui/SET_LOADING_TEXT", "Logging in!");
      this.$store.commit("ui/SET_LOADING", true);
      this.$store
        .dispatch("auth/login", this.form)
        .then(() => {
          this.$store.commit("ui/SET_LOADING", false);
          this.$router.push({ name: "overview" });
        })
        .catch(() => {
          this.valid = false;
          this.$store.commit("ui/SET_LOADING", false);
        });
    },
    onFocus() {
      this.valid = true;
    }
  }
};
</script>
<style scoped>
.tailie-input {
  background: white;
}
</style>
